// extracted by mini-css-extract-plugin
export var text = "_92-0";